export default __webpack_public_path__ + "static/media/group.fa4993e1.svg";